import format from './format.js';

function getNeigborhoodList(pageData, appUrl) {
    let neighborhoods = (pageData && pageData.topNeighborhoodList) || [];
    let list = [];
    neighborhoods.sort((a, b) => {
        return b.medianListPrice - a.medianListPrice
    });
    neighborhoods.forEach((neigh) => {
        if (neigh && neigh.sitemapNeighborhoodPageUrl && neigh.displayName) {
            list.push(`<a href=\"${appUrl + neigh.sitemapNeighborhoodPageUrl}\" class=\"link\">${neigh.displayName}</a>`);
        }
    });
    return list.join(', ');
}

function _getGeoDisplayText(geo) {
    if (!geo) {
        return {displayName : '', displayFullName: ''};
    }
    switch (geo.geoType) {
        case 'ZIPCODE':
            return {
                displayName : geo.zipcode,
                displayFullName : `${geo.zipcode}, ${geo.state}`
            };
        case 'NEIGHBORHOOD':
            return {
                displayName : geo.neighborhood,
                displayFullName : `${geo.neighborhood} ${geo.city}, ${geo.state}`
            }
        case 'COUNTY':
            return {
                displayName : geo.county,
                displayFullName : `${geo.county}, ${geo.state}`
            }
        case 'CITY':
        case 'ADDRESS':
            return {
                displayName : geo.city,
                displayFullName : `${geo.city}, ${geo.state}`
            }
        case 'STATE':
            return {
                displayName : geo.state,
                displayFullName : geo.state
            }
        default:
            return {displayName : '', displayFullName: ''};
    }
}

function getRaiseOrReduceDesc(value){
    let str = '';
    if(!value){
        return str;
    }
    if(!Number(value.split('%')[0])){
        str = 'same as ';
    }
    if(value.indexOf('+') >= 0){
        str = `a ${formatMTPercentage(value)} increase over`
    }
    if(value.indexOf('-') >= 0){
        str = `a ${formatMTPercentage(value)} decrease to `;
    }
    return str;
}

function increaseOrDecrease(value) {
    let str = '';
    if(!value){
        return str;
    }
    if(!Number(value.split('%')[0])){
        str = 'same';
    }
    if(value.indexOf('+') >= 0){
        str = `increased`
    }
    if(value.indexOf('-') >= 0){
        str = `decreased`;
    }
    return str;
}

function formatMTPercentage(value) {
    if (isMTValueExist(value)) {
        if (value.charAt(0) == '-') {
            return value.replace('-', '');
        }
        if (value.charAt(0) == '+') {
            return value.replace('+', '');
        }
    }
    return ''
}

function isMTValueExist(value) {
    if (value == '' || value === null || value == undefined) {
        return false;
    }
    return true;
}

function getAgoDates(snapshotData, field, noOfMonths) {
    let dateFormatOptions = { year: 'numeric', month: 'long' };
    if(snapshotData[field] && snapshotData[field].formatedDate) {
        return new Date(snapshotData[field].formatedDate).toLocaleDateString("en-US", dateFormatOptions)
    } else {
        let now = new Date();
        let customMonth = now.setMonth(now.getMonth() - noOfMonths);
        return new Date(customMonth).toLocaleDateString("en-US", dateFormatOptions)
    }
}

function getTemperatures(localHighlightGeo) {
    let X , Y = ''
    if(localHighlightGeo && localHighlightGeo.length) {
        for(let geo of localHighlightGeo) {
            if(geo.sectionTitle == "Climate" && geo.list && geo.list.length) {
                for(let item of geo.list) {
                    if(item.title == 'Temperature') {
                        if(item.monthlyAverage && item.monthlyAverage.summerHigh) {
                            X = item.monthlyAverage.summerHigh
                        }
                        if(item.monthlyAverage && item.monthlyAverage.winterHigh) {
                            Y = item.monthlyAverage.winterHigh
                        }
                        break;
                    }
                }
            }
        }
    }
    return { summer: X, winter: Y }
}

function getPercIncDec(lastyr,curr) {
    let increase = curr - lastyr
    let perc = Math.round((increase / lastyr) * 100)
    return `${perc}%`
}


function getFaqData(pageData, geo, appUrl, getSplit) {
    const faq = [];
    const displayObj = _getGeoDisplayText(geo);
    const displayName = displayObj.displayName
    const displayFullName = displayObj.displayFullName;
    const formatPrice = format.formatPrice;
    const friendlyPrice = format.friendlyPrice;
    const snapshotData = pageData.snapshotData
    const dateFormatOptions = { year: 'numeric', month: 'long' };
    const today = snapshotData && snapshotData.today;
    const isZipCodeSearch = pageData.searchType === 'ZIPCODE';
    const contentVariant = pageData.contentVariant || {};
    const lastUpdated = today && today.formatedDate ? new Date(today.formatedDate).toLocaleDateString("en-US", dateFormatOptions) : new Date().toLocaleDateString("en-US", dateFormatOptions)
    let faq7, faq8 = ''
    if(today) {
        let medianPrice = today.allTypeMedianListPrice;
        let oneMonthAgo = getAgoDates(snapshotData , 'one_month_ago' , 1)
        let oneYearAgo = getAgoDates(snapshotData , '' , 12)
        let MedianPricePerSqft1yrAgo = today.allTypeMedianPricePerSqftHousePercentageCompareWith1YearAgo

        let faq1ans1 = lastUpdated && medianPrice ? `In ${lastUpdated} ${displayName} homes were listed to buy for a median price of $${friendlyPrice(medianPrice)},` : ''
        let faq1ans3 = lastUpdated && today.allTypeMedianPricePerSqftHouse ? `The median value of a home listed to buy in ${displayName} in ${lastUpdated} was ${formatPrice(today.allTypeMedianPricePerSqftHouse)} per sqft,` : ''
        let faq1ans2 = ''
        let faq1ans4 = ''

        if(snapshotData && snapshotData.one_year_ago) {
            let oneMonthAgoLastyr = new Date(snapshotData.one_year_ago.formatedDate).toLocaleDateString("en-US", dateFormatOptions)
            if(faq1ans1) {
                let lastyrMedianPrice = snapshotData.one_year_ago.allTypeMedianListPrice
                let medianListPrice1yr1mAgo = getRaiseOrReduceDesc(getPercIncDec(lastyrMedianPrice, medianPrice))
                let yearPriceVarStr = getRaiseOrReduceDesc(today.allTypeMedianListPricePercentageCompareWith1YearAgo)
                faq1ans2 = medianListPrice1yr1mAgo && yearPriceVarStr ? `which is ${medianListPrice1yr1mAgo} ${oneMonthAgoLastyr} last month, and ${yearPriceVarStr} ${oneYearAgo} last year.`: ''
            }
            if(faq1ans3) {
                let medianPricePerSqft = today.allTypeMedianPricePerSqftHouse
                let medianPricePerSqft1yr1mAgo = snapshotData.one_year_ago.allTypeMedianPricePerSqftHouse
                let lastMontTxt = getRaiseOrReduceDesc(getPercIncDec(medianPricePerSqft1yr1mAgo, medianPricePerSqft))
                let yearPricepersqftVarStr = getRaiseOrReduceDesc(MedianPricePerSqft1yrAgo)
                faq1ans4 = lastMontTxt && yearPricepersqftVarStr ? `which is ${lastMontTxt} ${oneMonthAgoLastyr} last month, and ${yearPricepersqftVarStr} ${oneYearAgo} last year.` : ''
            }
        }
        if (!isZipCodeSearch && (faq1ans1 || faq1ans2 || faq1ans3 || faq1ans4)) {
            let faq1 = {
                question: 'How much does it cost to buy a house in ' + displayFullName + '?',
                answer: `${faq1ans1} ${faq1ans2} ${faq1ans3} ${faq1ans4}`,
            };
            faq.push(faq1);
        }

        if(today.allTypeMedianListPrice) {
            let nationalAvg = 425000
            let isExpensive = today.allTypeMedianListPrice > nationalAvg
            let perc = Math.round(today.allTypeMedianListPrice / nationalAvg)
            let faq2 = {
                question: `Is it affordable or expensive to ${contentVariant.isUnfilteredUnpaginatedCity ? 'buy real estate' : 'live'} in ${displayFullName}?`,
                answer: `It is ${isExpensive ? 'expensive' : 'affordable'} to ${
                    contentVariant.isUnfilteredUnpaginatedCity ? 'buy a house' : 'live'
                } in ${displayName}. Buying a home in ${displayName} is ${perc}% ${isExpensive ? 'more' : 'less'} expensive compared with the national average.`,
            };
            faq.push(faq2);
        }

        if(MedianPricePerSqft1yrAgo) {
            let changeText = increaseOrDecrease(MedianPricePerSqft1yrAgo)
            let changeValue = formatMTPercentage(MedianPricePerSqft1yrAgo)
            if(changeText && changeValue) {
                let faq3 = {
                    question: `Is it a good time to buy ${contentVariant.isUnfilteredUnpaginatedCity ? 'real estate' : 'property'} in ${displayFullName}?`,
                    answer: `Yes now is a good time to buy property in ${displayName}, in ${lastUpdated}, homes in ${displayName} have ${changeText} in value (price per sqft) by ${changeValue} in the last year compared with ${oneYearAgo}.`,
                };
                faq.push(faq3);
            }
        }

        let medianListPrice1monAgo = today.allTypeMedianListPricePercentageCompareWith1MonthAgo
        let changeText = increaseOrDecrease(MedianPricePerSqft1yrAgo)
        let changeValue = formatMTPercentage(medianListPrice1monAgo)
        if(changeText && changeValue) {
            let isDropping = medianListPrice1monAgo && medianListPrice1monAgo.indexOf('-') > -1 ? 'are': 'not';
            let faq4 = {
                "question": "Are home prices dropping in " + displayFullName + "?",
                "answer": `Home price ${isDropping} dropping in ${displayName}, in ${lastUpdated}, homes to buy in ${displayName} have ${changeText} in median list price by ${changeValue} compared with ${oneMonthAgo}, one month ago.`
            };
            faq.push(faq4);
        }

        let medianDOM1yrAgo = today.allTypeMedianDomPercentageCompareWith1YearAgo
        if(medianDOM1yrAgo) {
            let isSlowingDown = medianDOM1yrAgo.indexOf('-') > -1
            let isHeatingUp = medianDOM1yrAgo.indexOf('+') > -1
            let faq5ans1 = isSlowingDown || isHeatingUp ? `The housing market in ${displayName} is ${isSlowingDown ? 'slowing down': 'heating up'}.` : ''
            let faq5ans2 = today.allTypeMedianDom
                ? `In ${lastUpdated}, homes ${contentVariant.isUnfilteredUnpaginatedCity ? 'for sale' : 'to buy'} in ${displayName} spent ${
                      contentVariant.isUnfilteredUnpaginatedCity ? 'a median of' : 'an median'
                  } ${today.allTypeMedianDom} days on the market, a ${formatMTPercentage(medianDOM1yrAgo)} ${
                      isHeatingUp ? ' increase from ' : isSlowingDown ? ' decrease from ' : ' same '
                  } ${oneYearAgo} last year.`
                : '';
            if(faq5ans1 || faq5ans2) {
                let faq5 = {
                    "question": `Is the ${displayFullName} housing market slowing down?`,
                    "answer": `${faq5ans1} ${faq5ans2}`
                };
                faq.push(faq5);
            }
        }
        if(medianPrice) {
            let taxRateByState = {
                AL: 0.43,
                AK: 1.21,
                AS: 0, //American Samoa
                AZ: 0.84,
                AR: 0.62,
                CA: 0.81,
                CO: 0.62,
                CT: 1.91,
                DE: 0.53,
                DC: 0.57,
                FM: 0, //Federated States Of Micronesia
                FL: 1.10,
                GA: 0.96,
                GU: 0, //Guam
                HI: 0.28,
                ID: 0.77,
                IL: 2.25,
                IN: 0.88,
                IA: 1.47,
                KS: 1.41,
                KY: 0.84,
                LA: 0.48,
                ME: 1.27,
                MH: 0, //Marshall Islands
                MD: 1.08,
                MA: 1.18,
                MI: 1.83,
                MN: 1.19,
                MS: 0.78,
                MO: 1.00,
                MT: 0.87,
                NE: 1.88,
                NV: 0.92,
                NH: 2.10,
                NJ: 2.29,
                NM: 0.72,
                NY: 1.58,
                NC: 0.85,
                ND: 1.22,
                MP: 0, //Northern Mariana Islands,
                OH: 1.55,
                OK: 0.87,
                OR: 1.08,
                PW: 0, //Palau
                PA: 1.51,
                PR: 0, //Puerto Rico
                RI: 1.61,
                SC: 0.57,
                SD: 1.36,
                TN: 0.75,
                TX: 1.93,
                UT: 0.69,
                VT: 1.72,
                VI: 0, //Virgin Islands
                VA: 0.80,
                WA: 1.08,
                WV: 0.59,
                WI: 1.97,
                WY: 0.62
            }
            let homeInsurance = Math.round(medianPrice / 2000 * 3.5);
            let homeInsurancePerMonth = Math.round(homeInsurance/12)
            let taxAnnualAmount = taxRateByState[geo.state] / 100 * medianPrice
            let taxPerMonth = Math.round(taxAnnualAmount/ 12); //Annual Property Tax
            let downpayment = Math.round(medianPrice * 25 / 100);
            var loanAmount = medianPrice - downpayment; //Loan Amount
            var interestMonthRate = (6 / 100) / 12; //Monthly Interest Rate
            var loanMonth = 30 * 12; //Terms (mth)
            var _l = Math.pow((1 + interestMonthRate), loanMonth);
            let loanPerMonth = Math.round(loanAmount * (interestMonthRate * _l) / (_l - 1)); //Loan/mth
            let internetPerMonth = 50;
            let monthlyInstallment = homeInsurancePerMonth + taxPerMonth + loanPerMonth + internetPerMonth;
            let annualIncome = (monthlyInstallment * 12) / 0.35

            faq7 = {
                "question": "How much money should I make to buy a house in " + displayFullName + "?",
                "answer": `In ${lastUpdated}, ${displayName} homes were listed to buy for a median price of $${friendlyPrice(medianPrice)}, with 25% down you would need $${friendlyPrice(monthlyInstallment)}/month to cover expenses and assume that's 35% of your total monthly income, your total yearly income would need to be $${friendlyPrice(annualIncome)}.`
            };
        }

        if(MedianPricePerSqft1yrAgo) {
            let changeText = increaseOrDecrease(MedianPricePerSqft1yrAgo)
            let changeValue = formatMTPercentage(MedianPricePerSqft1yrAgo)
            if(changeText && changeValue) {
                faq8 = {
                    "question": "Is it a good time to sell my house in " + displayFullName + "?",
                    "answer": `Yes now is a good time to sell your house in ${displayName}, in ${lastUpdated}, homes in ${displayName} have ${changeText} in value (price per sqft) by ${changeValue} in the last year compared with ${oneYearAgo}.`
                };
            }
        }
    }

    let faqNeighborhood = getNeigborhoodList(pageData, appUrl);
    if(faqNeighborhood && !getSplit('movoto-reduce-msp-internal-links-CW-3433')) {
        let faq6 = {
            "question": "What are the best and safest places to live in " + displayFullName + "?",
            "answer": "The best and safest neighborhoods to live in "+ displayName+ " in " + lastUpdated + " are " + faqNeighborhood
        };
        faq.push(faq6);
    }

    if(faq7) {
        faq.push(faq7);
    }

    if(faq8) {
        faq.push(faq8);
    }

    const schoolData = pageData.schoolData
    if(schoolData) {
        let schools = schoolData.list || []
        let high = schoolData.high || (schools.length && schools.filter(school => (school.highSchoolInd === true))) || 0
        let middle = schoolData.middle || (schools.length && schools.filter(school => (school.middleSchoolInd === true))) || 0
        let ele = schoolData.elementary || (schools.length && schools.filter(school => (school.elementarySchoolInd === true))) || 0
        if(high > 7 || middle > 7 || ele > 7 ) {
            let faq9 = {
                "question": "Does " + displayFullName + " have good public schools?",
                "answer": `Yes, ${displayName} has ${high} high schools, ${middle} middle schools, & ${ele} elementary schools with an 8+ GreatSchools rating.`
            };
            faq.push(faq9);
        }
    }

    let temperature = getTemperatures(pageData.localHighlightGeo)
    if(temperature.summer && temperature.winter) {
        let faq10 = {
            "question": "Does the weather in " + displayFullName + " make it a nice place to live?",
            "answer": `Yes, ${displayName} weather makes it a nice place to live with highs in the summer of ${temperature.summer}°F to ${temperature.winter}°F in the winter.`
        };
        faq.push(faq10);
    }

    return faq
}


export default {
    getFaqData
};